import { render, staticRenderFns } from "./PaypalDone.vue?vue&type=template&id=2905db85&"
import script from "./PaypalDone.vue?vue&type=script&lang=js&"
export * from "./PaypalDone.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports